import TabPanel from "../Reusable/Tab";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import EditPickupRequest from "./EditPickupRequest";
import EditPickupNote from "./EditPickupRequest";

const SwitchTab = (props: any) => {
  const {
    isLoading,
    data,
    defaultValue,
    setDefaultValue,
    id,
    handleUpdate,
    handleMarkAsDone,
 
  } = props;

  return (
    <>
      <TabPanel
        tabTitle={["Update", "Documents"]}
        tabPanels={[
          <>
            <EditPickupNote
              isLoading={isLoading}
              data={data}
              defaultValue={defaultValue}
              setDefaultValue={setDefaultValue}
              handleUpdate={handleUpdate}
              handleMarkAsDone={handleMarkAsDone}
            />
          </>,
          <>
            <FileUpload object_id={id} />
          </>,
        ]}
      />
    </>
  );
};

export default SwitchTab;
